/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_koopovereenkomst = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	this.onready = function() {

		/*
		Open and close checkbox
		*/
		$('.js-koopovereenkomst-checkbox').on('click',function() {

			specific_koopovereenkomst.toggle_checkbox(
				$(this)
			);

		});

		/*
		Open and close category
		*/
		$('.js-koopovereenkomst-category').on('click',function() {

			specific_koopovereenkomst.toggle(
				$(this)
			);

		});

		/*
		Make 1000s on input
		*/
		$('.js-input-total').on('input',function() {

			var value;
			
			if ($(this).val().charAt(0) == '€') {
				value = $(this).val().substring(1).split('.').join('');
			} else { 
				value = $(this).val().split('.').join('');
			}

		    if (value.length > 3) {
		      value = value.substring(0, value.length - 3) + '.' + value.substring(value.length - 3, value.length);
		    }

			$(this).val('€' + value);

		});

		/*
		Submit
		*/
		$('.js-agreement-send').on('click',function() {

			/*
			Check if signatures are filled in
			*/
			var _signature_1_active = $('.js-agreement-signature-box[data-signature-from="buyer"]').hasClass('active');
			var _signature_2_active = $('.js-agreement-signature-box[data-signature-from="partner"]').hasClass('active');
			var _signature_3_active = $('.js-agreement-signature-box[data-signature-from="advisor"]').hasClass('active');

			if(
				_signature_1_active == true &&
				_signature_3_active == true
			) {
				var _agreement_id 		= $('.js-agreement-id').val();

				/*
				XHR: Exact.php first
				XHR: Exact.php first
				XHR: Exact.php first
				XHR: Exact.php first
				*/

				/*
				Show: Modal
				*/
				//modal.open('loading');

				// $.ajax({
				// 	url: globalUrl + '/exact.php',
				// 	data: {
				// 		'what':'koopovereenkomst'
				// 	},
				// 	type: "POST",
				// 	headers: { 
				// 		'go-load':1
				// 	}
				// })
				// .done(function(data) {

				// 	setTimeout(function() {

				// 		modal.close();

				popup.open(1,1,'project-koopovereenkomst-pdf/' + _agreement_id);

				// 	},1000);

				// })
				// .always(function() {
				// });

			} else {
				alert('Niet alle handtekeningen zijn ingvuld. Probeer nogmaals.');
			}

		});

		/*
		Open signature
		*/
		$('.js-agreement-signature-box').on('click',function() {
			var _type 				= $(this).data('signature-type');
			var _from 				= $(this).data('signature-from');
			var _agreement_id 		= $('.js-agreement-id').val();

			popup.open(1,1,'signature/' + _type + '/' + _from + '/' + _agreement_id);
		});
	
	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************

	// none

	/*
	Toggle checkbox
	*/
	this.toggle_checkbox = function(_this) {

		var _category 		= _this.parent().parent().parent();
		var _agreement_id 	= $('.js-agreement-id').val();

		var _open_or_close;

		if(
			$(_this).is(":checked")
		) {
			$(_category).addClass('active-checkbox');
			_checked = 'yes';
		} else {
			$(_category).removeClass('active-checkbox');
			_checked = 'no';
		}

		/*
		Ajax:
		*/
		$.ajax({
			url: globalUrl + '/a/a/agreement-checkbox-update',
			type: "POST",
			data: {
				agreement_id	: _agreement_id,
				tab				: _this.data('id'),
				value 			: _checked
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {
		})
		.always(function() {
		});

	};

	/*
	Toggle box *************************
	Toggle box *************************
	Toggle box *************************
	Toggle box *************************
	*/
	this.toggle = function(_this) {

		var _category 		= _this.parent().parent();
		var _agreement_id 	= $('.js-agreement-id').val();

		/*
		Toggle
		*/
		var _open_or_close;

		if(
			$(_category).hasClass('active')
		) {
			$(_category).removeClass('active');
			_open_or_close = 'no';

			/*
			Reset
			*/
			//$('.js-category-' + _this.data('id')).find('input').val('');
			//$('.js-category-' + _this.data('id')).find('select').prop('selectedIndex',0);
			// ALREADY GONG EARLIER // $('.js-category-' + _this.data('id')).find('textarea').val();

			//console.log(_this.data('id'));

			/*
			Catch the new empty values in an array
			*/
			// var _values_array = [];

			// $('.js-category-' + _this.data('id') + ' .js-input').map(function() { 

			// 	var _data_id 	= $(this).data('id');

			// 	/*
			// 	Check select or text
			// 	*/
			// 	var _value;

			// 	if ($(this).is('select')) {
			// 		_value 		= $(this).children('option:selected').val();
			// 	} else {
			// 		_value 		= $(this).val();
			// 	}

			// 	_values_array[_values_array.length] = [
			// 		_data_id,
			// 		_value
			// 	];
			// });

			/*
			Ajax: Reset
			*/
			// $.ajax({
			// 	url: globalUrl + '/a/a/agreement-accordeon-reset',
			// 	type: "POST",
			// 	data: {
			// 		agreement_id	: _agreement_id,
			// 		tab				: _this.data('id'),
			// 		values 			: _values_array
			// 	},
			// 	headers: { 
			// 		'go-load':1 
			// 	}
			// })
			// .done(function(data) {
			// })
			// .always(function() {
			// });

		} else {
			
			$(_category).addClass('active');
			_open_or_close = 'yes';

		}

		/*
		Ajax:
		*/
		$.ajax({
			url: globalUrl + '/a/a/agreement-accordeon-update',
			type: "POST",
			data: {
				agreement_id	: _agreement_id,
				tab				: _this.data('id'),
				value 			: _open_or_close
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {
		})
		.always(function() {
		});
		

	};
		
}).apply(specific_koopovereenkomst); 